'use strict';

const root = typeof window === 'undefined' ? global : window;

root.abExperiments = root.abExperiments || {};

module.exports = root.abExperiments;
